export type JobOpening = {
  id: string;
  title: string;
  location: string;
  description: string[];
  skills: string[];
  applyEmail: string;
  applyUrl: string;
};

export const jobOpenings: JobOpening[] = [
  {
    id: 'phone-support-specialist',
    title: 'MX Locker Phone Support Specialist',
    location: 'Remote',
    description: [
      "As an MX Locker Phone Support Specialist, you'll be on the front line helping riders, buyers, and sellers get the support they need. You'll answer inbound calls, guide customers through marketplace questions, and help resolve issues related to accounts, listings, orders, offers, shipping, returns, and payouts.",
      "You'll work closely with our support and operations teams to make sure every customer interaction is handled clearly, professionally, and with care. Whether someone is trying to list their first item, track an order, understand seller fees, or troubleshoot an account issue, you'll help them move forward with confidence.",
      'This role is a great fit for someone who communicates well, stays calm under pressure, and enjoys helping people. A strong interest in motocross, powersports, gear, parts, or marketplace businesses is a big plus.',
    ],
    skills: [
      'Strong phone communication skills and a customer-first mindset.',
      'Comfortable handling inbound customer calls in a clear, professional, and friendly tone.',
      'Ability to explain marketplace processes like buying, selling, shipping, offers, returns, and payouts.',
      'Strong problem-solving skills with attention to detail.',
      'Comfortable using support tools, admin dashboards, email, chat, and internal documentation.',
      'Ability to stay calm and organized when helping frustrated or confused customers.',
      'Strong sense of ownership and follow-through.',
      'Good written communication skills for notes, follow-ups, and internal escalations.',
      'Interest in motocross, powersports, riding gear, parts, or enthusiast communities is preferred.',
      'Previous customer support, call center, marketplace, e-commerce, or retail experience is a plus.',
    ],
    applyEmail: 'support@mxlocker.com',
    applyUrl:
      'https://docs.google.com/forms/d/e/1FAIpQLSeXpZ0_U7Xg4w0WuwaqAWKRuoXdWqfOzBlePJcyGOvJpYn-eg/viewform',
  },
];
